import { type SerializedError } from '@reduxjs/toolkit'
import { type FetchBaseQueryError } from '@reduxjs/toolkit/query'
import {
  type UserClaims,
  type CustomUserClaims
} from '@okta/okta-auth-js'
import { type ButtonProps } from 'antd'

import { AuthzedApiV1ZedToken } from '../../state/apis/generated/relationshipsApi'

export type ICurrentUser = Partial<UserClaims<CustomUserClaims>>

export interface IProjectResource {
  resourceId: string
  resourceType: string
  namespace: string
}

export interface INamespaceItem {
  key: string
  label: string
}

export interface IUserPermission extends IProjectResource {
  relation: string
  expiresAt?: string | null
}

export interface IDrawerFooterBlock {
  tooltipText?: string
  confirm: ButtonProps
  cancel?: ButtonProps
  delete?: ButtonProps
}

export type ICreateEditPanelState = {
  operation: 'create' | 'edit'
  payload?: IUserPermission
} | null

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  PROVISIONED = 'PROVISIONED',
  SUSPENDED = 'SUSPENDED'
}

export type IRTKQResponseResult = {
  data: AuthzedApiV1ZedToken
} | {
  error: FetchBaseQueryError | SerializedError
}

export type ISelectOption = { label: string, value: string }
